document.addEventListener('turbo:load', function () {
	$(function () {
		/* pageTopBtn */
		$(window).on('load scroll', function () {
			var windowScroll = $(window).scrollTop();
			var windowHeight = window.innerHeight;
			if ($('.js-pagetop').length) {
				var btnStopPos = $('.js-pagetop').offset().top;
			}
			btnStopPos = btnStopPos - windowHeight;
			if (windowScroll > 100) {
				$('.js-pagetop').addClass('view');

				if ((windowScroll > btnStopPos)) {
					$('.js-pagetop').removeClass('fixed');
				} else {
					$('.js-pagetop').addClass('fixed');
				}
			} else {
				$('.js-pagetop').removeClass('fixed');
				$('.js-pagetop').removeClass('view');
			}
		});
		//チェックボックス
		$('.uk-checkbox').on('click', function () {
			$(this).parents('label').toggleClass('uk-active');
		});
		//絞り込み検索reset
		$('.js-clear').on('click', function () {
			$('.modal-search .uk-checkbox').prop('checked', false).parents('label').removeClass('uk-active');
			$('option').prop('selected', false);
			$('.is-selected-wrap').html('');
			$('.is-selected').removeClass('uk-active');
			return false;
		});
		$(document).on("click", ".is-selected-wrap > div", function () {
			$(this).html('');
			var id = $(this).attr('id');
			$('input[value="' + id + '"]').prop('checked', false).parents('label').removeClass('uk-active');

			chkSearchChecked();
			return false;
		});
		//絞り込み検索を閉じた時
		UIkit.util.on('#select-jobs,#select-kaihatsu,#select-remote,#select-other', 'hidden', function () {
			chkSearchChecked();
		});
		//絞り込み検索の現在値を表示
		chkSearchChecked();
		function chkSearchChecked() {
			$('.is-selected-wrap').html('');
			$('.is-selected').removeClass('uk-active');
			$('.modal-search .uk-checkbox:checked').each(function () {
				var name = $(this).next('span').html();
				var val = $(this).val();
				var html = '<div id="' + val + '"><button type="button" class="uk-button uk-label uk-button-small uk-button-selected">' + name + '<i class="uk-icon" uk-icon="close"></i></button></div>';
				$('.is-selected-wrap').append(html);
				$('.is-selected').addClass('uk-active');
			});
		}

		// Remoguキャリアリダイレクトをキャンセルする場合の処理
		$('.cancel-redirect').on('click', function () {
			window.cancelRedirect = true;
		});

		// ページ水増し用検索リンクのアコーディオンを開く
		$('.search-link-accordion-btn').on('click', function () {
			$(this).hide(); // ボタンを非表示にする
			const accordion = $(this).closest('div').siblings('ul.search-link-accordion')[0]; // DOM要素を取得
			if (accordion) {
				accordion.style.maxHeight = 'none'; // max-heightを解除
			}
		});
	});
	//横幅リサイズ時の処理
	var timer = false;
	var prewidth = $(window).width();
	if (prewidth < 480) {
		new ScrollHint('.js-scrollable');
		//UIkit.slider('.js-scrollable');
	}
	$(window).resize(function () {
		if (timer !== false) {
			clearTimeout(timer);
		}
		timer = setTimeout(function () {
			var nowWidth = $(window).width();
			if (prewidth !== nowWidth) {
				//リサイズしたらスタートに戻る
				UIkit.slider('.jobsliders').show(0);
			}
			if (nowWidth < 480) {
				new ScrollHint('.js-scrollable');
				//UIkit.slider('.js-scrollable');
				//UIkit.slider('.js-scrollable').show(0);
			}
			prewidth = nowWidth;
		}, 200);
	});

	// アコーディオン初期状態のサイズ計算処理
	const accordions = document.querySelectorAll('.search-link-accordion');
	let visibleItems = 2; // 表示したいliの数
	if ($(window).width() < 480) {
		// 画面サイズが小さい場合は1つのli要素のみ表示
		visibleItems = 1;
	}
	accordions.forEach(accordion => {
		const items = accordion.querySelectorAll('li');
		if (items.length > 0) {
			const liHeight = items[0].offsetHeight; // 最初のli要素の高さを取得
			accordion.style.maxHeight = `${liHeight * visibleItems + 10}px`; // max-heightを設定
		}
	});
});